export enum LanguageCode {
    DE = 'de',
    EN = 'en',
}
